import React from 'react'

import './buttons.css'

const Component = (props) => {
	const classnames = `button primary ${props.className}`
  return (
  	<button 
  		{...props}
  		className={classnames}
  		onClick={props.onClick}>
  		{props.title}
  	</button>
  )
}
export default Component